export default __webpack_public_path__ + "static/media/A0003.9ac9f971.png";